<h5>
  <div *ngIf="fournisseur?.id !== 0">
    <span *ngIf="fournisseur.site && fournisseur.site.id" class="space">
    <label class="badge badge-secondary">
      <yo-site [siteId]="fournisseur?.site?.id" [siteLibelle]="fournisseur?.site?.libelle"></yo-site>
    </label>
    </span>

    <label class="badge badge-secondary mg-r-20">
      <i class="fas fa-handshake mg-r-5"></i>
      <yo-viewmode
        [yoLabelFab]="'Fournisseur'" [libelle]="fournisseur?.libelle"
        [siteId]="fournisseur?.site?.id">
      </yo-viewmode>
    </label>
  </div>
  <div *ngIf="fournisseur?.id === 0">
    <label class="badge badge-secondary">
      <i class="fas fa-handshake"></i>
      <span class="mg-l-5">Création d'un fournisseur</span>
    </label>
  </div>
</h5>
<p-tabMenu [model]="navLinks" [activeItem]="selectedNavLink"></p-tabMenu>
<div>
  <router-outlet></router-outlet>
</div>
